import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const cards = [
  {
    id: 1,
    title: "Cambridge",
    image:
      "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/cambridge-wide.webp", // Replace with your image
    description:
      "Immerse yourself in the academic excellence of Cambridge, with an array of subjects in a world-renowned environment.Immerse yourself in the academic excellence of Cambridge, with an array of subjects in a world-renowned environment.Immerse yourself in the academic excellence of Cambridge, with an array of subjects in a world-renowned environment.",
  },
  {
    id: 2,
    title: "Oxford",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/oxford-wide.webp", // Replace with your image
    description:
      "Study in the historic city of Oxford. Embrace each college’s unique atmosphere and stunning surroundings.Study in the historic city of Oxford. Embrace each college’s unique atmosphere and stunning surroundings.Study in the historic city of Oxford. Embrace each college’s unique atmosphere and stunning surroundings.",
  },
  {
    id: 3,
    title: "London",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-London.webp", // Replace with your image
    description:
      "Experience the best of London through diverse programs that foster both academic growth and cultural exploration.Experience the best of London through diverse programs that foster both academic growth and cultural exploration.Experience the best of London through diverse programs that foster both academic growth and cultural exploration.",
  },
  {
    id: 4,
    title: "Sydney",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-Sydney.webp", // Replace with your image
    description:
      "Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.",
  },
  {
    id: 5,
    title: "New York",
    image: "https://env-immerseeducation-stagingmain.kinsta.cloud/wp-content/uploads/2024/04/Location-Background-New-York.webp", // Replace with your image
    description:
      "Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.Study in the beautiful city of Sydney, known for its vibrant atmosphere and rich academic offerings.",
  },
];

const Impacts = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration (ms)
      once: true, // Whether animation should happen only once
    });
  }, []);

  return (
    <div className="container mx-auto px-4 md:px-10 py-10 w-full ">
      <h1 className="text-2xl md:text-2xl lg:text-4xl notoh font-bold text-gray-800  text-center mt-5 mb-10 md:mb-14">
        Our Summer Schools
      </h1>
  
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {cards.map((card) => (
          <div
            key={card.id}
            className="relative group rounded-xl overflow-hidden shadow-lg"
            data-aos="fade-right" // AOS animation for cards
          >
            {/* Background Image */}
            <img
              src={card.image}
              alt={card.title}
              className="w-full h-[500px] object-cover transform group-hover:scale-110 transition-transform duration-500"
            />
  
            {/* Static Title */}
            <div className="absolute top-4 left-4">
              <h3 className="text-3xl font-bold text-white px-4 py-2 rounded-lg hover:text-white">
                {card.title}
              </h3>
            </div>
  
            {/* Hover Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex flex-col justify-start p-6">
              {card.description && (
                <p className="text-white text-sm mt-12">{card.description}</p>
              )}
            </div>
  
            {/* Bottom Arrow Button */}
            <div
              className="absolute bottom-4 left-4 bg-white text-black rounded-full p-3 group-hover:scale-110 transition-transform duration-300"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
  
};

export default Impacts;